import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpTokenInterceptor, LoadingInterceptor, ErrorInterceptor } from './helpers';
import { MocksInterceptor } from './mocks';

import {
  ApiService,
  AuthService,
  CustomerService,
  ProductService,
  CartService,
  InventoryService,
  AdditionalService,
  UserService,
  OrderPaymentService,
  GoogleAnalyticsService
} from './services';

@NgModule({
  imports: [CommonModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MocksInterceptor, multi: true },
    ApiService,
    AuthService,
    CustomerService,
    ProductService,
    CartService,
    InventoryService,
    AdditionalService,
    UserService,
    OrderPaymentService,
    GoogleAnalyticsService
  ]
})
export class CoreModule {}
